import * as Yup from 'yup';
import React, { useState, useRef, useEffect } from 'react';
import { Link as RouterLink, useNavigate, useParams } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import {
  Link,
  Stack,
  Checkbox,
  TextField,
  IconButton,
  InputAdornment,
  FormControlLabel,
  Typography,
  Avatar,
  Chip,
  Card,
  Input,
  Button
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Box } from '@mui/system';
import { makeStyles, styled } from '@mui/styles';
import DriveIcon from '@mui/icons-material/DriveEta';
import FileBase64 from 'react-file-base64';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import secureLocalStorage from 'react-secure-storage';
import { ToastContainer, toast } from 'material-react-toastify';
import 'material-react-toastify/dist/ReactToastify.css';

const useStyles = makeStyles((theme) => ({
  headerContainer: {
    position: 'relative',
    height: '100px'
  },
  header: {
    display: 'flex',
    position: 'absolute',
    width: 'calc(100%)',
    top: '10px',
    left: '20px',
    alignItems: 'flex-end',
    '& > *': {
      margin: '24px 8px'
    }
  },
  spacer: {
    flexGrow: '1'
  },
  avatar: {
    border: `3px solid white`,
    width: 80,
    height: 80
  },
  actionGroup: {
    display: 'flex',
    width: '330px',
    justifyContent: 'space-between',
    marginRight: 0
  },
  summaryCards: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  summaryCard: {
    margin: 8,
    flexGrow: 1,
    padding: 24
  },
  tripCard: {
    margin: 8,
    padding: 16
  },
  input: {
    display: 'none'
  },
  large: {
    width: 100,
    height: 100
  }
}));

const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: '#f78181'
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#f78181'
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'lightgray',
      borderRadius: 0
    },
    '&:hover fieldset': {
      borderColor: '#f78181'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#f78181'
    }
  }
});

export default function ProfileClassForm() {
  const classes = useStyles();
  const [t, i18n] = useTranslation();
  const [baseImage, setBaseImage] = useState('');
  const [client, setClient] = useState([]);
  const [userName, setUserName] = useState('');

  function convertBase64(photo) {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(photo);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  }
  const uploadImage = async (e) => {
    const file = e.target.files[0];
    const base64 = await convertBase64(file);
    setBaseImage(base64);
  };
  const hiddenFileInput = React.useRef(null);
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const notifySuccess = () => {
    toast.success('Your nursery has been updated', {
      position: 'bottom-right',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });
  };
  const notifyErrorProfile = (messageError) => {
    toast.error(messageError, {
      position: 'bottom-right',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });
  };
  // GET one Class
  const { id } = useParams();
  const retrieveArtisan = async () => {
    const token = localStorage.getItem('access');
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    const response = await axios({
      method: 'get',
      url: `${API_ENDPOINT}/api/detail_classes/${id}`,
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  };

  useEffect(async () => {
    const oneClient = await retrieveArtisan();
    console.log('class', oneClient);
    setClient(oneClient);
    console.log('cl555', client);
    setUserName(oneClient.code);
  }, []);

  const ProfileSchema = Yup.object().shape({
    code: Yup.string().required('code is required'),
    creche_id: Yup.string().required('creche id is required')
  });

  const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      code: client.code,
      creche_id: client.creche_id
    },
    validationSchema: ProfileSchema,
    onSubmit: (values) => {
      const token = localStorage.getItem('access');
      console.log('data', values);
      axios({
        method: 'put',
        url: `${API_ENDPOINT}/api/detail_classes/${id}/`,
        headers: { Authorization: `Bearer ${token}` },
        data: values
      })
        .then((res) => {
          setUserName(res.data.code);
          notifySuccess();
          console.log('response.data', res.data.data);
        })
        .catch((err) => {
          console.log('err', err);
          if (err.response.status >= 500) {
            notifyErrorProfile('Network Error');
          } else if (err.response.status >= 400 && err.response.status <= 403) {
            notifyErrorProfile('Email or phone number already bound to an existing account.');
          } else {
            notifyErrorProfile(err.message);
          }
        });
    }
  });
  const { errors, touched, isSubmitting, getFieldProps, setFieldValue, values } = formik;

  if (client.length === 0) {
    return (
      <div>
        <h1>Load ...</h1>
      </div>
    );
  }

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={formik.handleSubmit}>
        <ToastContainer />
        <div
          style={{
            height: '280px',
            backgroundSize: 'cover',
            filter: 'contrast(70%)',
            backgroundImage: 'url(/static/slider/child.jpg)'
          }}
        />
        <div className={classes.headerContainer}>
          <div className={classes.header}>
            <Typography style={{ padding: '0px 30px', textTransform: 'capitalize' }} variant="h5">
              {userName}
            </Typography>
            <Chip label="Class" style={{ backgroundColor: '#ec8181', color: 'white' }} />
          </div>
        </div>
        <Stack style={{ padding: '30px' }} spacing={3}>
          <CssTextField
            fullWidth
            required
            type="text"
            label={t('codeclasse')}
            {...getFieldProps('code')}
            error={Boolean(touched.code && errors.code)}
            helperText={touched.code && errors.code}
          />
          <Box textAlign="right" justifyContent="space-between">
            <Button
              style={{ maxWidth: '100px', backgroundColor: '#f78181' }}
              type="submit"
              variant="contained"
              loading={isSubmitting}
            >
              {t('modifier')}
            </Button>
          </Box>
        </Stack>
      </Form>
    </FormikProvider>
  );
}
